const React = require('react');
const FormFooter = require('../FormFooter');

module.exports = ({submitBtnData, additionalBtnsList}) => (
  <FormFooter
    submitBtnData={{...submitBtnData, changesCheckDisabled: true}}
    additionalBtnsList={additionalBtnsList}
  />
);
